import React, { useState } from 'react';
import { Heart, MessageCircle, Share2, Send, Award, Shield, User } from 'lucide-react';
import '../styles/global.css';

const Community = () => {
  // --- MOCK DATA (Updated for Monad Narrative) ---
  const [posts, setPosts] = useState([
    {
      id: 1, user: "Rahul Sharma", role: "Verified Citizen", avatar: "https://i.pravatar.cc/150?u=rahul",
      content: "Great news! The massive pothole near Sector 18 has been filled. Safe driving! #RoadSafety",
      likes: 24, comments: 5, time: "2h ago", liked: false
    },
    {
      id: 2, user: "Priya Singh", role: "Community Guardian", avatar: "https://i.pravatar.cc/150?u=priya",
      content: "⚠️ Heavy water logging on Ring Road. Avoid service lane. Stay safe! 🌧️",
      likes: 89, comments: 12, time: "5h ago", liked: true
    },
    {
      id: 3, user: "Amit Verma", role: "New Member", avatar: "https://i.pravatar.cc/150?u=amit",
      // KEY CHANGE: Specific mention of Monad to sell the story
      content: "Just earned my first 50 $GUARD tokens on Monad Testnet for reporting a broken streetlight! 💡💰",
      likes: 15, comments: 2, time: "1d ago", liked: false
    }
  ]);

  const [leaderboard] = useState([
    { name: "Priya Singh", points: 1250, badge: "🥇" },
    { name: "Vikram Malhotra", points: 980, badge: "🥈" },
    { name: "Rahul Sharma", points: 850, badge: "🥉" },
    { name: "Neha Gupta", points: 720, badge: "4" },
  ]);

  const [newPostContent, setNewPostContent] = useState('');

  const handleLike = (id) => {
    setPosts(posts.map(post => post.id === id ? { ...post, likes: post.liked ? post.likes - 1 : post.likes + 1, liked: !post.liked } : post));
  };

  const handlePostSubmit = (e) => {
    e.preventDefault();
    if (!newPostContent.trim()) return;
    const newPost = {
      id: Date.now(), user: "You", role: "Citizen Reporter",
      avatar: "https://cdn-icons-png.flaticon.com/512/149/149071.png",
      content: newPostContent, likes: 0, comments: 0, time: "Just now", liked: false
    };
    setPosts([newPost, ...posts]);
    setNewPostContent('');
  };

  return (
    <div className="container" style={{ paddingTop: '100px', maxWidth: '1200px', margin: '0 auto', paddingBottom: '40px' }}>
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '10px', fontWeight: 'bold' }}>Community Hub</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem' }}>Connect with citizens making roads safer on Monad.</p>
      </div>

      <div style={{ display: 'flex', gap: '30px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
        
        {/* LEFT FEED */}
        <div style={{ flex: '2 1 600px', minWidth: '300px' }}>
          <div className="glass-panel" style={{ padding: '20px', marginBottom: '30px' }}>
            <div style={{ display: 'flex', gap: '15px' }}>
              <div style={{ width: '45px', height: '45px', borderRadius: '50%', background: 'var(--glass-border)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                 <User size={24} color="var(--text-muted)" />
              </div>
              <div style={{ flex: 1 }}>
                <textarea 
                  placeholder="Share a safety update..." value={newPostContent} onChange={(e) => setNewPostContent(e.target.value)}
                  style={{ width: '100%', border: 'none', background: 'transparent', color: 'var(--text-main)', fontSize: '1rem', resize: 'none', outline: 'none', minHeight: '60px' }}
                />
                <div style={{ borderTop: '1px solid var(--glass-border)', marginTop: '10px', paddingTop: '10px', display: 'flex', justifyContent: 'flex-end' }}>
                  <button onClick={handlePostSubmit} className="btn-primary" style={{ padding: '8px 20px', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '8px' }} disabled={!newPostContent.trim()}>
                    <Send size={16} /> Post
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {posts.map(post => (
              <div key={post.id} className="glass-panel" style={{ padding: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <img src={post.avatar} alt={post.user} style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }} />
                    <div>
                      <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600' }}>{post.user}</h4>
                      {/* Monad Purple for Roles */}
                      <span style={{ fontSize: '0.8rem', color: '#8b5cf6', fontWeight: '500' }}>{post.role}</span>
                    </div>
                  </div>
                  <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{post.time}</span>
                </div>
                <p style={{ lineHeight: '1.6', marginBottom: '20px', color: 'var(--text-main)', fontSize: '0.95rem' }}>{post.content}</p>
                <div style={{ display: 'flex', gap: '25px', borderTop: '1px solid var(--glass-border)', paddingTop: '15px' }}>
                  <button onClick={() => handleLike(post.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', color: post.liked ? '#ef4444' : 'var(--text-muted)', fontSize: '0.9rem', fontWeight: '500' }}>
                    <Heart size={18} fill={post.liked ? "#ef4444" : "none"} /> {post.likes}
                  </button>
                  <button style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', color: 'var(--text-muted)', fontSize: '0.9rem', fontWeight: '500' }}><MessageCircle size={18} /> {post.comments}</button>
                  <button style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', color: 'var(--text-muted)', fontSize: '0.9rem', fontWeight: '500' }}><Share2 size={18} /> Share</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDEBAR */}
        <div style={{ flex: '1 1 300px', minWidth: '280px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div className="glass-panel" style={{ padding: '25px' }}>
            <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', fontSize: '1.2rem' }}>
              <Award color="#f59e0b" size={24} /> Top Contributors
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {leaderboard.map((user, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: '10px', borderBottom: index < leaderboard.length - 1 ? '1px solid var(--glass-border)' : 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ fontWeight: 'bold', width: '20px', fontSize: '1.1rem' }}>{user.badge}</span>
                    <span style={{ fontSize: '0.95rem', fontWeight: '500' }}>{user.name}</span>
                  </div>
                  {/* Monad Purple for Points */}
                  <span style={{ color: '#8b5cf6', fontWeight: 'bold', fontSize: '0.9rem' }}>{user.points} GUARD</span>
                </div>
              ))}
            </div>
            <button className="glass-btn" style={{ width: '100%', marginTop: '20px', padding: '12px', fontSize: '0.9rem', color: '#8b5cf6', borderColor: '#8b5cf6' }}>View Full Leaderboard</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Community;